import React from 'react';
import Line from './Line';
var validThresholds = function (thresholds) {
    return thresholds !== undefined && thresholds.goal !== undefined;
};
var goalIs100 = function (thresholds) {
    return thresholds !== undefined && thresholds.goal !== undefined && thresholds.goal === 100;
};
var goalIs0 = function (thresholds) {
    return thresholds !== undefined && thresholds.goal !== undefined && thresholds.goal === 0;
};
var TrendlineChartGoal = function (_a) {
    var scaleX = _a.scaleX, scaleY = _a.scaleY, yMin = _a.yMin, yMax = _a.yMax, xMin = _a.xMin, xMax = _a.xMax, data = _a.data;
    return (React.createElement("g", null, data.filter(function (d, i) { return data[i + 1]; }).map(function (d, i) { return (validThresholds(d.thresholds) && data[i + 1] !== undefined && validThresholds(data[i + 1].thresholds) &&
        React.createElement(Line, { key: i, x1: scaleX(d.x ? d.x : i), x2: scaleX(data[i + 1].x || i + 1), y1: scaleY(goalIs100(d.thresholds) ? (goalIs0(data[i + 1].thresholds) ? yMin : yMax) : (goalIs100(data[i + 1].thresholds) ? yMax : yMin)), y2: scaleY(goalIs100(d.thresholds) ? (goalIs0(data[i + 1].thresholds) ? yMin : yMax) : (goalIs100(data[i + 1].thresholds) ? yMax : yMin)), className: "trendlineChartGoal", strokeWidth: 3 })); })));
};
export default TrendlineChartGoal;
//# sourceMappingURL=TrendlineChartGoal.js.map